import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Gdpr.css';

class Gdpr extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.banner}>GDPR policy</div>
        <div className={s.section}>
          <h1>Spotmentor is GDPR ready</h1>
          <p>Last Updated: 10th November, 2019</p>
          <p>
            We’re committed to protecting our customers’ data. We’ve especially
            developed processes, technologies, and policies that ensure we
            deliver on our data security promise.
          </p>
          <p>
            The really good thing is that our already-in-place privacy and
            security practices align with the requirements of the GDPR
            regulation. And that is why more than 1,500 businesses count on us
            to keep their data safe and secure.
          </p>
        </div>
        <div className={s.section}>
          <h2>What really is GDPR?</h2>
          <p>
            First off, in case you were wondering, GDPR stands for General Data
            Protection Regulation. Broadly speaking, it aims to simplify and
            streamline the data regulatory environment for businesses.
          </p>
          <p>
            At its core, GDPR is a new set of rules designed to give EU citizens
            more control over their personal data. It adds a list of new
            requirements about how companies should protect individuals’
            personal data they collect and use.
          </p>
          <p>
            In the simplest of words, GDPR aims to control how individuals and
            organizations may obtain, use, store, and remove personal data. EU
            citizens will now have complete control over their personal data.
          </p>
          <p>
            You can read all about GDPR{' '}
            <a href="https://gdpr-info.eu/ ">here.</a>
          </p>
        </div>
        <div className={s.section}>
          <h2>Is Spotmentor GDPR compliant?</h2>
          <p>
            By all means. Spotmentor is fully compliant with the GDPR
            guidelines.
          </p>
          <p>
            We have always been extremely careful about handling our customers’
            data and our existing security practices already met most aspects of
            the new data privacy rules.
          </p>
          <p>
            We still went ahead and undertook an extensive internal audit to
            ensure we comply with all the GDPR regulations.
          </p>
        </div>
        <div className={s.section}>
          <h2>Does Spotmentor have a Data Protection Officer?</h2>
          <p>
            Yes, we’ve appointed a Data Protection Representative who will
            ensure that our employees across teams are trained on the
            requirements of the regulation and comply with it.
          </p>
          <p>The DPO is responsible for:</p>
          <ul>
            <li>
              Educating the company and employees on important compliance
              requirements
            </li>
            <li>Training staff involved in data processing</li>
            <li>
              Conducting audits to ensure compliance and address potential
              issues proactively
            </li>
            <li>
              Serving as the point of contact between the company and GDPR
              Supervisory Authorities
            </li>
            <li>
              Monitoring performance and providing advice on the impact of data
              protection efforts
            </li>
            <li>
              Maintaining comprehensive records of all data processing
              activities conducted by the company, including the purpose of all
              processing activities, which must be made public on request
            </li>
            <li>
              Interfacing with data subjects to inform them about how their data
              is being used, their rights to have their personal data erased,
              and what measures the company has put in place to protect their
              personal information
            </li>
          </ul>
        </div>
        {/*<div className={s.section}>
          <h2>
            What steps has Spotmentor taken to ensure the safety of its
            customers’ data?
          </h2>
          <p>
            Here’s a quick lowdown of what Spotmentor is doing to protect your
            data:
          </p>
          <h3>Data Processing Addendum</h3>
          <p>
            We’ve created a{' '}
            <a href="https://Spotmentorhq.com/agreements/dpa/Spotmentor_-_Data_Processing_Addendum.pdf ">
              Data Processing Addendum
            </a>{' '}
            - a legal agreement that Spotmentor’s customers and third parties
            can request from us. The document promises the correct use of
            personally identifiable information stored with Spotmentor.
          </p>
          <h3>Privacy Shield Certifications</h3>
          <p>
            To comply with the international EU data protection laws around
            international data transfers, we’ve completed the{' '}
            <a href="https://www.privacyshield.gov/participantamp;status=Active ">
              E.U.-U.S. and Swiss-U.S. Privacy Shield
            </a>{' '}
            certifications. They ensure your data is a 100 percent safe during
            transfers from EU (and Switzerland) to the US.
          </p>
          <h3>Infrastructure and physical security</h3>
          <p>
            All of our services and data are hosted on the Amazon Web Services
            (AWS) in the US. AWS complies with leading security policies and
            frameworks including SAS70 level II, SSAE 16, SOC framework and ISO
            27001.
          </p>
        </div>*/}
        <div className={s.section}>
          <h2>Safeguard Data Inventory</h2>
          <p>
            We’ve carefully identified the areas of Spotmentor where we collect
            user information and applied security and privacy safeguards across
            the entire ecosystem. At every step in our infrastructure, we ensure
            that we validate our legal basis for collecting and processing
            customer data.{' '}
            {/*Our <a href="/privacy ">Privacy Policy</a> elaborates
            on the data we collect and how we manage consent.*/}
          </p>
        </div>
        {/*<div className={s.section}>
          <h2>Documented Subprocessors</h2>
          <p>
            We’ve created an exhaustive{' '}
            <a href="https://Spotmentorhq.com/third-party-subprocessors ">
              list of third party Subprocessors -
            </a>{' '}
            third party services that assist Spotmentor in providing service.
            There are instances when we have to share customers’ personally
            identifiable data with them. We have an active mechanism in place to
            keep it up to date.
          </p>
        </div>*/}
        <div className={s.section}>
          <h2>Consent</h2>
          <p>
            We went ahead and updated our{' '}
            <a href="/legal/cookie-policy">Cookie Policy</a> to tell you clearly
            what information we collect when you visit the Spotmentor website,
            and how we use it. The page also explains how you can control your
            browser to accept or refuse cookies.
          </p>
        </div>
        <div className={s.section}>
          <h2>Right to erase</h2>
          <p>
            In case a registered person needs to delete his details, the process
            for such deletion exists in the system. The request can be raised
            from the help section on the platform or you can contact our data
            protection officer. Your data will be deleted within 30 working
            days after raising the request.
          </p>
        </div>
        <div className={s.section}>
          <h2>Automated decision making</h2>
          <p>
            We use automated decision making for profiling, if any person has
            any concerns with the results of the automated processing can object
            to such processing by stating the grounds of your objection to the
            data controller.
          </p>
        </div>
        <div className={s.section}>
          <h2>Internal training</h2>
          <p>
            We’ve ensured that our employees are trained on data privacy and
            GDPR guidelines. Everyone at Spotmentor is well versed with their
            responsibilities regarding security, process integrity, and
            confidentiality of customer data.
          </p>
        </div>
        <div className={s.section}>
          <h2>Updates to Terms of Service</h2>
          <p>
            In the wake of the new rules, we went ahead and updated our Terms of
            Service to include the DPA and other clauses required by GDPR.
          </p>
        </div>
        <div className={s.section}>
          <h2>What kind of data does Spotmentor collect?</h2>
          <p>
            When you use our product, our server saves the following details
            Database.
          </p>
          <ul>
            <li>Email Id</li>
            <li>Full name</li>
            <li>Gender</li>
            <li>Current Organisation name</li>
            <li>Date of Joining/Quitting the organisation</li>
            <li>Contact number</li>
            <li>Resume</li>
            <li>Work experience</li>
            <li>Education details</li>
          </ul>
          <p>That’s all.</p>
        </div>
        <div className={s.section}>
          <h2>Have questions?</h2>
          <p>
            Should you have any questions about GDPR or Data Privacy, you can
            always write the data protection officer at{' '}
            <a href="mailto:arpit@spotmentor.com" target="_blank">
              arpit@spotmentor.com
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Gdpr);



// WEBPACK FOOTER //
// ./src/routes/legal/gdpr/Gdpr.js